import { forwardRef } from 'react'
import type { PickerProps } from 'antd/es/date-picker/generatePicker'
import { RangePickerRef } from 'antd/es/date-picker/generatePicker/interface'
import cl from 'classnames'
import { Moment } from 'moment'

import { DatePickerIcon } from '../DatePicker/DatePicker'

import RangePickerWrapper from './RangePickerWrapper'

import styles from './styles.module.scss'

export interface RangePickerPropsI extends Omit<PickerProps<Moment>, 'picker'> {}

const RangePicker = forwardRef<RangePickerRef<Moment>, RangePickerPropsI>(
	({ className, size = 'large', ...props }, ref) => (
		<RangePickerWrapper.RangePicker
			className={cl(styles.rangePicker, className)}
			{...props}
			size={size}
			ref={ref}
			suffixIcon={<DatePickerIcon />}
		/>
	)
)
RangePicker.displayName = 'RangePicker'

export default RangePicker
